import { render, staticRenderFns } from "./LabelsInformation.vue?vue&type=template&id=16a93e44&"
import script from "./LabelsInformation.js?vue&type=script&lang=js&"
export * from "./LabelsInformation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports